<script>
    import Carousel from './Carousel.svelte';
    import Livestream from './Livestream.svelte';
    export let events;
    console.log('upcoming events: ',events);
    console.log('events.length: ', events.length);
    // let eventSelected = events[0];
    let mode = 'upcoming';
    $: eventSelected = events[0];
</script>

{#if mode==='upcoming' && events.length !== 0}
    <h1>Upcoming events</h1>
    <div id="event-info">
        <h1>{eventSelected.name}</h1>
        <br/><button on:click={()=>mode = 'livestream'}>Livestream Dashboard</button>
    </div>
    <Carousel on:eventSelected={(event)=> eventSelected = event.detail.event} {events}/>
{:else if events.length===0}
        <h1>loading upcoming events</h1>
{:else}
    <header id="header">
        <button on:click={()=>mode = 'upcoming'}>back to events</button> &nbsp;<h1>Livestream Dashboard</h1>
    </header>
    <Livestream event={eventSelected} />
{/if}

<style>
    #header {
        display: flex;
    }
</style>